import React, { useCallback, useState } from "react";
import { BiCloudUpload } from "react-icons/bi";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";

import Text from "../../../components/typography/Text";
import ProgressBar from "./ProgressBar"

const DragAndDrop = ({
  onChange = () => {},
  accept = "image/*, .csv, .xls, .xlsx,image/jpeg,image/jpg",
  maxFiles = 1,
  label = "Upload Excel, Csv, max size 5MB each.",
}) => {
  const [files, setFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);

  const simulateUpload = () => {
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setUploadProgress(progress);
      if (progress >= 100) clearInterval(interval);
    }, 300);
  };

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length > maxFiles) {
        toast(`You can only upload up to ${maxFiles} file(s).`);
        return;
      }

      const validFiles = acceptedFiles.filter((file) =>
        accept.includes(file.type) || accept.includes(file.name.split(".").pop())
      );

      if (validFiles.length === 0) {
        toast(`Please select valid files (${accept}).`);
        return;
      }

      setFiles(validFiles);
      onChange(validFiles);
      setUploadProgress(0);
      simulateUpload();
    },
    [accept, maxFiles, onChange]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: accept,
    multiple: maxFiles > 1,
  });

  return (
    <div className="  w-[650px] h-auto bg-white ">
         
      <div
        {...getRootProps()}
        className="flex flex-col gap-6 rounded-lg p-5 border border-dashed border-gray-400 text-center cursor-pointer transition transform hover:scale-95"
      >
        <input {...getInputProps()} />
       
        <div className="flex flex-col items-center">
          <BiCloudUpload size={60} className="text-blue-500" />
          <Text className="text-sm font-[500]  text-[#282828]">Drop your file here,or <span className="text-[#0184FF]">click to browse</span></Text>
          <Text className="text-gray-600 text-xs font-[400]">{label}</Text>
        </div>
        {/* <CustomButton variant="outlined" className="border-primary text-primary" label="Browse Files" /> */}
      </div>

      {files.length > 0 && (
        <div className="mt-4 p-3 ">
          
          {files.map((file, index) => (
            <ProgressBar
            key={index}
            fileName={file.name}
            fileType={file.name.split(".").pop() || ""}
            progress={uploadProgress}
            currentSize={`${((file.size * uploadProgress) / (100 * 1024 * 1024)).toFixed(1)}MB`}
            totalSize={`${(file.size / (1024 * 1024)).toFixed(1)}MB`}
            onCancel={() => {
              setFiles([]);
              setUploadProgress(0);
            }}
          />
          ))}
        </div>
      )}

      {/* {uploadProgress === 100 && (
        <div className="mt-3 flex justify-end gap-2">
          <CustomButton variant="outlined" label="Cancel" onClick={() => setFiles([])} />
          <CustomButton variant="primary" label="Submit" />
        </div>
      )} */}
    </div>
  );
};

export default DragAndDrop;
